import { memo, useMemo } from 'react'
import useAuth from 'src/hooks/useAuth'
import useRouter from 'src/hooks/useRouter'
import { checkValuesInArray } from 'src/utils'
import Item from './Item'

const SubItem = ({ items, onMobileClose }) => {
  const { pathname } = useRouter()
  const { user } = useAuth()

  const href = useMemo(() => {
    const arrayOfPath = pathname.split('/')
    const path = `/${arrayOfPath[1]}/${arrayOfPath[2]}/${arrayOfPath[3]}`
    return path
  }, [pathname])

  return items.map((value) => {
    const isActive = href === value.href

    return (
      checkValuesInArray(value.allowedRoles, user?.roles) && (
        <Item
          onMobileClose={onMobileClose}
          key={value.href}
          value={value}
          isActive={isActive}
        />
      )
    )
  })
}

export default memo(SubItem)
